import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiService } from '../services/api';

const EventDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await apiService.getPublicEventById(id);
        setData(res.data);
      } catch (error) {
        console.error('Failed to load event detail', error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  if (loading) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center text-gray-600">Loading event detail...</div>;
  }

  if (!data?.event) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-700 mb-4">Event tidak ditemukan.</p>
          <Link to="/event" className="text-green-600 font-semibold">Kembali ke daftar event</Link>
        </div>
      </div>
    );
  }

  const { event, registrations = [], groups = [] } = data;

  return (
    <div className="min-h-screen bg-gray-50 py-8 sm:py-10">
      <div className="container mx-auto px-4 space-y-6">
        <div className="bg-white rounded-xl shadow p-5 sm:p-6">
          <div className="flex items-center justify-between gap-3 mb-3">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{event.name}</h1>
            <Link to="/event" className="text-sm text-green-700 font-semibold">Kembali</Link>
          </div>
          <p className="text-gray-700 mb-4">{event.description || '-'}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
            <div className="bg-gray-50 rounded p-3"><span className="font-semibold">Format:</span> {event.format}</div>
            <div className="bg-gray-50 rounded p-3"><span className="font-semibold">Lokasi:</span> {event.location || '-'}</div>
            <div className="bg-gray-50 rounded p-3"><span className="font-semibold">Kategori:</span> {(event.categories || []).join(', ')}</div>
            <div className="bg-gray-50 rounded p-3"><span className="font-semibold">Status:</span> {event.status}</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-5 sm:p-6">
          <h2 className="text-xl font-bold mb-4">Peserta Terdaftar ({registrations.length})</h2>
          {registrations.length === 0 ? (
            <p className="text-gray-600">Belum ada peserta terdaftar.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-2">Tim</th>
                    <th className="text-left py-2">Kategori</th>
                    <th className="text-left py-2">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {registrations.map((reg) => (
                    <tr key={reg.id} className="border-b last:border-b-0">
                      <td className="py-2">{reg.team_name || '-'}</td>
                      <td className="py-2">{reg.category}</td>
                      <td className="py-2">{reg.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {event.format === 'tournament_elimination' && (
          <div className="bg-white rounded-xl shadow p-5 sm:p-6">
            <h2 className="text-xl font-bold mb-4">Group Stage</h2>
            {groups.length === 0 ? (
              <p className="text-gray-600">Group stage belum tersedia.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {groups.map((group) => (
                  <div key={group.id} className="border rounded-lg p-4 bg-gray-50">
                    <h3 className="font-semibold mb-2">{group.group_name}</h3>
                    <p className="text-sm text-gray-600">Kategori: {group.category}</p>
                    <p className="text-sm text-gray-600">Jumlah tim: {(group.teams || []).length}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetail;
